import * as Segments from '../models/Segments';
import be from './Backend';
import Assignment from './Assignment';

export default function(actions) {    

    let service = {
        mode: undefined,
        index: undefined,
        session: undefined,
        results: undefined,
        assignment: undefined,
    };

    let active = 0;
    let segments = []
    let questionContainer;

    function start(code, sid = undefined, index = false) {
        //console.log('assignment', code, sid, index);
        return Promise.all([
            be.MIA.getAssignment(code), 
            sid ? be.MIA.getAssignmentSession(code, sid) : be.MIA.getAssignmentSessionLatest(code)
        ]).then(([assignment, session]) => {
            console.log('ass - ses', assignment, session);
            service.index      = index;
            service.session    = session;
            service.assignment = Assignment().parse(assignment);
        }).then((results) => {
            service.results = results;
            parse(service.assignment, service.session);            
            return load();
        }).catch(console.error);
    }

    function parse(assignment, session) {
        
        segments.push(parseSession(assignment, session));        
        segments.push(parseQuestions(assignment, session));
    }

    function parseSession(assignment, session) {

        if (session) {

            if (session.status === 'open') {
                return new Segments.Function({ type: 'continue-session' });
            }
            if (session.status === 'finished' && assignment.maxNumberOfCompletions === 1) {                
                return new Segments.Function({ type: 'finished' });
            }
        }

        return new Segments.Function({ type: 'create-session' });
    }

    function parseQuestions(assignment, session) {

        questionContainer = new Segments.QuestionContainer();
        
        for (let questions of assignment.questions) {
            let types = questions.map(q => q.module);
            let match = Segments.QuestionSegmentRules.match(types);

            if (match) {
                let component = match.component;
                let indexes = questions.map(q => q.index);
                let data = questions.map((q) => ({ question: q, answer: undefined }));

                //console.log('cid', component, indexes, data);

                // Setup default explanation per component
                // if(typeof data[0].question.explanation != 'string' || !data[0].question.explanation.text) {
                //     switch(component) {
                //         case "SelfTestModule":
                //             data[0].question.explanation = "Schuif de eigenschap in een vak";
                //             break;
                //         default:
                //             if(data[0].question.explanation) {
                //                 data[0].question.explanation = data[0].question.explanation.text;
                //             }
                //             break;
                //     }
                // }
                // console.log('explanation', data[0].question.explanation);
                

                questionContainer.addSegment(indexes, new Segments.QuestionSegment(component, data));
            } else {
                console.warn('[skipping] Could not match segment for type(s): ' + types.join(', '));
            }
        }        
        //console.log('questionContainer', questionContainer);

        return questionContainer;
    }

    function load() {
        let segment = segments[active];
        if (!segment) {
            throw 'Segment out of bounds';
        }

        // Get all actions defined to run on load
        let loadActions = [segment.load()].flat();        

        var deffered = new Promise((resolve) => {    
            resolve();
        });

        // Create the promise chain
        for (let {type, args} of loadActions) {
            // deep copy otherwise the state will get remembered partially            
            deffered = deffered.then(() => actions[type](args ? Object.freeze(JSON.parse(JSON.stringify(args))) : args))
        }

        return deffered;
    }

    function previous() {
        let segment = segments[active];
        
        let isConsumed = typeof segment.previous === 'function' && segment.previous();
        if (!isConsumed) {
            active--;
        }
        
        if (active >= 0) {
            return load();
        } else {
            //return close();
        }
    }

    function next() {
        let segment = segments[active];
        
        let isConsumed = typeof segment.next === 'function' && segment.next();
        if (!isConsumed) {
            active++;
        }
        
        if (active < segments.length) {
            return load();
        } else {
            //return close();
        }
    }

    function finish() {
        return be.MIA.finishAssignmentSession(service.assignment.code, service.session.id);
    }

    function getActiveSegmentIndex() {
        return questionContainer.active;
    }

    function getSegmentsLength() {
        return questionContainer.segments.length;
    }

    function getSegments() {
        return questionContainer.segments;
    }

    function setAnswer(answer) {
        questionContainer.setAnswer(answer.questionId, answer);
    }

    function getService() {
        return service;
    }

    actions = actions || {};
    Object.assign(actions, {
        'next': next,
        'update-position': ({index}) => {
            if (service.session && service.mode === 'learner') {
                return be.MIA.postAssignmentSessionPosition(service.assignment.code, service.session.id, index);                
            }
        },
        'load-route': ({route, state, data}) => {
            return Promise.resolve();
        },
        'create-session': () => {

            service.mode = 'learner';

            // Create session
            return be.MIA.createAssignmentSession(service.assignment.code).then(session => {
                service.session = session;

                // Set question index
                questionContainer.setActive(service.session && service.session.position);
                questionContainer.setActiveByIndex(service.index); 

                return next();
            });
        },
        'continue-session': () => {
            
            service.mode = 'learner';

            // Get answers and update questions
            return be.MIA.getAssignmentSessionAnswers(service.assignment.code, service.session.id).then(answers => {

                for (let answer of answers) {
                    questionContainer.setAnswer(answer.questionId, answer)
                }
                
                // Set question index
                questionContainer.setActive(service.session && service.session.position);
                questionContainer.setActiveByIndex(service.index); 
                
                return next();
            });
        }
    });

    return {
        start,
        previous,
        next,
        finish,
        getActiveSegmentIndex,
        getSegmentsLength,
        getSegments,
        setAnswer,
        getService
    }
}
